import api from './api';

const authService = {
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (e) {
      console.error(e);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
    }
  },

  obtenerUsuario: () => {
    try {
      const usuario = localStorage.getItem('usuario');
      if (!usuario || usuario === 'undefined' || usuario === 'null') return null;
      return JSON.parse(usuario);
    } catch {
      localStorage.removeItem('usuario');
      return null;
    }
  },

  estaAutenticado: () => !!localStorage.getItem('token'),
};

export default authService;